// Module
var code = `<!-- ko if: page -->
<div class="svc-page__content" data-bind="click: select, key2click, clickBubble: false, css: css, attr: { id: page.id, 'data-sv-drop-target-survey-page': dropTargetName }, event: { dblclick: (d, e) => dblclick(e), mouseover: function(m, e) { hover(e, \$element); }, mouseleave: function(m, e) { hover(e, \$element); } }">
  <div class="svc-question__drop-indicator svc-question__drop-indicator--top"></div>
  <div class="svc-question__drop-indicator svc-question__drop-indicator--bottom"></div>
  <!-- ko if: allowDragging && !isGhost -->
  <div class="svc-question__drag-area" data-bind="event: { pointerdown: (model, event)=>{ onPointerDown(event); return true; } }">
    <!-- ko component: { name: 'sv-svg-icon', params: { css: 'svc-question__drag-element', iconName: 'icon-drag-area-indicator_24x16', size: 'auto' } } -->
    <!-- /ko -->
    <div class="svc-page__content-actions">
      <!-- ko component: { name: 'sv-action-bar', params: { model: actionContainer } } -->
      <!-- /ko -->
    </div>
  </div>
  <!-- /ko -->
  <!-- ko if: !allowDragging || isGhost -->
  <div class="svc-page__content-actions">
    <!-- ko component: { name: 'sv-action-bar', params: { model: actionContainer } } -->
    <!-- /ko -->
  </div>
  <!-- /ko -->
  <!-- ko template: { name: 'survey-page', data: page } -->
  <!-- /ko -->
  <!-- ko if: \$data.showPlaceholder -->
  <div class="svc-page__placeholder_frame">
    <div class="svc-panel__placeholder_frame">
      <div class="svc-panel__placeholder" data-bind="text: \$data.placeholderText"></div>
    </div>
  </div>
  <!-- /ko -->
  <!-- ko component: { name: 'sv-action-bar', params: { model: footerActionsBar } } -->
  <!-- /ko -->
</div>
<!-- /ko -->`;
// Exports
export default code;